
import TitleBox from '@/components/CSS/TitleBox'
import CouponItem from '@/components/CouponItem'
export default {
    name: 'SelectCoupon',
    components: {
        TitleBox,
        CouponItem
    },
    data() {
        return {
            couponList: []
        }
    },
     mounted() {
         this.getExposureCouponData()
    },
    methods: {
        // 获取曝光优惠券列表
        async getExposureCouponData() {
            try {
                const data = {
                    ...this.$route.query
                }
                const res = await this.$api.getExposureCouponList(data)
                if(!res.success) {
                    this.$toast.error(res.msg)
                    return
                }
                this.couponList = res.data
            } catch (error) {
                this.$toast.error(error.message)
            }

        }
    }
}
